<template>
  <transition :name="transitionName">
    <div v-show="visible" ref="backtop"  :style="customStyle" @mouseover="handleover" @mouseout="handleOut" class="back-to-ceiling" @click="backToTop">
      <img class="back-img" src="../../assets/images/back_top_03.png" alt="">
      <img class="back-img-hover" src="../../assets/images/back_top_03_hover.png" alt="">
      <!--<svg width="16" height="16" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" class="Icon Icon&#45;&#45;backToTopArrow" aria-hidden="true" style="height: 16px; width: 16px;">-->
        <!--<title>回到顶部</title>-->
        <!--<g>-->
          <!--&lt;!&ndash;<path d="M543.261644 194.737028c-8.260053-8.264045-19.093138-12.393073-29.926222-12.390079-1.437225 0-2.87445 0.074855-4.304689 0.219576-0.173665 0.019961-0.342339 0.042917-0.516004 0.063877-0.493048 0.054894-0.988092 0.112782-1.481141 0.187638-0.340343 0.049904-0.682682 0.112782-1.021028 0.169672-0.317387 0.055892-0.637769 0.107792-0.95815 0.171669-0.433164 0.085834-0.863333 0.184644-1.291507 0.283453-0.224566 0.0519-0.447137 0.099807-0.668709 0.155699-0.486062 0.118771-0.966135 0.251514-1.44521 0.389248-0.167676 0.046909-0.338347 0.093819-0.506023 0.145719a39.044618 39.044618 0 0 0-1.520065 0.48706c-0.138732 0.047908-0.277464 0.092821-0.417195 0.13973a43.695638 43.695638 0 0 0-1.556993 0.588863c-0.119769 0.046909-0.233549 0.089827-0.349326 0.13973-0.534967 0.216582-1.064944 0.448135-1.583942 0.687673l-0.291437 0.129749c-0.549938 0.258501-1.093888 0.528979-1.63185 0.809437l-0.197618 0.100806c-0.583873 0.309403-1.159761 0.630782-1.729661 0.966134a42.512922 42.512922 0 0 0-9.142349 7.240022L119.237293 558.906938c-16.521103 16.521103-16.521103 43.30639 0 59.828492 16.520105 16.521103 43.356294 16.521103 59.877397 0L471.069024 326.826009v654.80579c0 23.36489 18.896517 42.372194 42.258413 42.372193h-0.159692c23.363892 0 42.144633-19.007303 42.144633-42.372193V326.719215l292.155945 291.803625c16.520105 16.519107 43.377253 16.409319 59.896361-0.214586h0.039923c16.522101-16.624903 16.534078-43.092802 0.010978-59.620892L543.261644 194.737028zM986.506887 58.534989c0-23.264085-18.863581-42.121677-42.128664-42.121678H76.457886c-23.264085 0-42.122675 18.85859-42.122676 42.121678 0 23.263087 18.85859 42.121677 42.122676 42.121677h867.919339c23.265083 0 42.128664-18.85859 42.128664-42.121677z" fill="#ffffff" p-id="2269"></path>&ndash;&gt;-->
          <!--<path d="M12.036 15.59c0 .55-.453.995-.997.995H5.032c-.55 0-.997-.445-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29c.39-.39 1.026-.385 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z" fill="#ffffff" fill-rule="evenodd"/>-->
        <!--</g>-->
      <!--</svg>-->
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    backPosition: {
      type: Number,
      default: 0
    },
    customStyle: {
      type: Object,
      default: function() {
        if(window.screen.width>1840)
        {
          return {
            // right: '0px',
            // bottom: '140px',
            "z-index": "5",
          }
        } else if(window.screen.width>1420)
        {
          return {
            // right: '0px',
            // bottom: '140px',
            "z-index": "5",
          }
        } else if(window.screen.width>750)
        {
          return {
            // right: '0px',
            // bottom: '140px',
            "z-index": "5",
          }
        } else
        {
          return {
            // right: "0.3rem",
            // bottom: "1rem",
            "z-index": "5",
          }
        }

      }
    },
    transitionName: {
      type: String,
      default: 'fade'
    }
  },
  data() {
    return {
      visible: false,
      interval: null,
      isMoving: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight
      // this.$refs.backtop.style.opacity = 0.3
    },
    handleover() {
      this.$refs.backtop.style.opacity = 1
    },
    handleOut() {
      // this.$refs.backtop.style.opacity = 0.3
      this.$refs.backtop.style.opacity = 1
    },
    backToTop() {
      this.$refs.backtop.style.opacity = 1
      if (this.isMoving) return
      const start = window.pageYOffset
      let i = 0
      this.isMoving = true
      this.interval = setInterval(() => {
        this.$refs.backtop.style.opacity = 1
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition)
          clearInterval(this.interval)
          // this.$refs.backtop.style.opacity = 0.3
          this.$refs.backtop.style.opacity = 1
          this.isMoving = false
        } else {
          window.scrollTo(0, next)
          // this.$refs.backtop.style.opacity = 1
        }
        i++
      }, 16.7)
    },
    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b
      return -c / 2 * (--t * (t - 2) - 1) + b
    }
  }
}
</script>

<style scoped lang="scss">
  .back-to-ceiling {
    bottom: 70px;
    position: fixed;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    /*opacity: 0.3;*/
    opacity: 1;
    z-index: 5;
    right: 0;
    img{
      width: 90px;
      height: 90px;
      height: auto;
      &.back-img{
        display: block;
      }
      &.back-img-hover{
        display: none;
      }
    }
  }
  .back-to-ceiling:hover{
    img{
      &.back-img{
        display: none;
      }
      &.back-img-hover{
        display: block;
      }
    }
  }

  /*.back-to-ceiling:hover {*/
    /*background: #d5dbe7;*/
  /*}*/

  /*.fade-enter-active,*/
  /*.fade-leave-active {*/
    /*transition: opacity .5s;*/
  /*}*/

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

  .back-to-ceiling .Icon {
    /*fill: #9aaabf;*/
    fill: #666;
    background: none;
  }

  @media screen and (max-width: 1840px){
    .back-to-ceiling {
      img{
        width: 90px;
        heigth: 90px;
      }
    }
  }
  @media screen and (max-width: 1420px){
    .back-to-ceiling {
      bottom: 140px;
      img{
        width: 60px;
        height: 60px;
      }
    }
  }
  @media screen and (max-width: 750px){
    .back-to-ceiling {
      bottom: 1rem;
      right: 0.3rem;
      img{
        width: 1.29rem;
        height: 1.29rem;
      }
    }

    .back-to-ceiling:hover{
      img{
        &.back-img{
          display: block;
        }
        &.back-img-hover{
          display: none;
        }
      }
    }
  }
</style>
